//
// [アドイン] このアイテムを誰が持ち出したか？の履歴の全表示（サーバー対応）
//
// ./ItemHistoryModal.js
//

import React, { useEffect, useState } from 'react';
import { useEscapeClose } from '../hooks/useEscapeClose';

function ItemHistoryModal({ itemId, itemName, onClose }) {

  /* Escで離脱できるように。 */
  useEscapeClose(onClose);

  /* ユーザーリスト読み出し */
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    fetch("https://newells4610.stars.ne.jp/data/userList.json", { cache: "no-store" })
      .then(res => res.json())
      .then(data => setUserList(data))
      .catch(err => {
        console.error("ユーザーリスト取得エラー", err);
        setUserList([]);
      });
  }, []);

  /* --- サーバーから持ち出し履歴を取得 --- */
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const res = await fetch("https://newells4610.stars.ne.jp/data/checkoutrecords.json", {
          cache: "no-store"
        });
        const all = await res.json();

  /* --- itemId を含む履歴だけ抽出 --- */
        const filtered = [];
        all.forEach(rec => {
          const hits = rec.items.filter(it => String(it.id) === String(itemId));
          if (hits.length) filtered.push({ ...rec, items: hits });
        });

        filtered.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setRecords(filtered);
      } catch (err) {
        console.error("履歴取得失敗", err);
        setRecords([]);
      }
    };

    fetchRecords();
  }, [itemId]);

  /* --- アイテム名を一行目タイトルに --- */
  // const firstHit = records[0]?.items[0];
  // const itemName = firstHit?.name || "(不明アイテム)";
  const itemTitle = itemName || "(不明アイテム)";

/* ----------------------------------------------------------------- */

  return (
    <div className="modal-overlay" style={{ zIndex: 1100 }}>
      <div className="modal-box" style={{ maxWidth: 520 }}>
        {/* 1行目：アイテム名 */}
          <h4 style={{ marginBottom: 4 }}>{itemTitle}</h4>
        {/* 2行目：固定文 */}
          <p style={{ margin: '0 0 8px', fontWeight: 'bold' }}>
            この部材を持ち出した人の全履歴
          </p>

        {/* 履歴リスト */}
        <div
          className="modal-list small-text"
          style={{ maxHeight: '60vh', overflowY: 'auto' }}
        >
          {records.length === 0 && <p>履歴はありません。</p>}

          {records.map((rec, i) => {
            const user = userList.find(u => String(u.id) === String(rec.user || rec.userId));
            const name = user?.name || rec.user || rec.userId;
            const date = new Date(rec.timestamp).toLocaleString();

            return rec.items.map((it, j) => (
              <div key={`${i}-${j}`} style={{ marginBottom: '4px' }}>
                <strong>{date}</strong>&nbsp;&nbsp;
                {name} さん&nbsp;&nbsp;→&nbsp;
                {it.quantity}
                {it.unit || '個'}
              </div>
            ));
          })}
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  );
}

export default ItemHistoryModal;
